const GroupPin = function gp(pin) {
  this.pinned = pin?.pinned;
};

export default GroupPin;
